import { Accordion } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MtfaAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: "none",
  borderTop: "0",
}));
